import React, { useState, useEffect } from 'react';
import { TOKENS } from '../tokens';
import api from '../api/client';
import { Briefcase, CheckCircle2, Clock } from 'lucide-react';

export function MyWorkScreen({ emp }) {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchMyWork();
  }, []);

  const fetchMyWork = async () => {
    try {
      const { data } = await api.get('/projects');
      setProjects(data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '16px 20px', paddingBottom: 100 }}>
      <h2 style={{ margin: '0 0 20px 0', fontFamily: 'Fraunces', color: TOKENS.navyDeep, fontSize: 24 }}>My Work</h2>

      {loading ? (
        <p>Loading projects...</p>
      ) : projects.length === 0 ? (
        <div style={{ background: '#fff', padding: 32, borderRadius: 16, textAlign: 'center', color: '#666', border: '1px solid #eee' }}>
          <Briefcase size={40} style={{ opacity: 0.2, marginBottom: 16 }} />
          <h3 style={{ margin: '0 0 8px 0' }}>No active projects</h3>
          <p style={{ margin: 0, fontSize: 14 }}>You haven't been assigned to any projects yet.</p>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          {projects.map(p => (
            <div key={p.project_id} style={{
              background: '#fff', borderRadius: 16, padding: 20,
              boxShadow: '0 4px 12px rgba(0,0,0,0.05)', border: '1px solid #eee'
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 12 }}>
                <span style={{ 
                  background: p.health === 'Green' ? '#E6F4EA' : p.health === 'Amber' ? '#FEF7E0' : '#FCE8E6',
                  color: p.health === 'Green' ? '#1E8E3E' : p.health === 'Amber' ? '#B06000' : '#D93025',
                  padding: '4px 8px', borderRadius: 12, fontSize: 12, fontWeight: 600
                }}>
                  {p.health || 'Green'}
                </span>
                <span style={{ fontSize: 12, color: '#888', fontWeight: 600 }}>{p.stage}</span>
              </div>
              <h3 style={{ margin: '0 0 4px 0', color: TOKENS.navyDeep, fontSize: 18 }}>{p.name}</h3>
              <p style={{ margin: 0, color: '#666', fontSize: 14 }}>Client: {p.client || 'Internal'}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
